import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { Gamepad2, Users, MapPin, Mountain, Trophy } from 'lucide-react';
import './HomePage.css';

const HomePage = () => {
  const { user } = useAuth();

  return (
    <div className="homepage">

      {/* ── Hero ── */}
      <section className="hero">
        <div className="hero-media">
          <video
            className="hero-video"
            autoPlay muted loop playsInline
            poster="https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=1920&q=80"
          >
            <source
              src="https://player.vimeo.com/external/434045526.sd.mp4?s=c27eba2f7e2dd8b9ee76e1e1c8cb7bc9c92e8a27&profile_id=164&oauth2_token_id=57447761"
              type="video/mp4"
            />
          </video>
          <div className="hero-overlay" />
        </div>

        <div className="hero-body container">
          <div className="hero-content animate-fade-up">
            <p className="hero-eyebrow">Nepal Geography Game</p>
            <h1 className="hero-title display">
              Explore Nepal
            </h1>
            <p className="hero-subtitle">
              One guess at a time.
            </p>
            <p className="hero-desc">
              100+ authentic locations across 75 districts. Pin where you think you are — the closer you get, the higher you score.
            </p>

            <div className="hero-cta">
              {user ? (
                <>
                  <Link to="/game">
                    <button className="cta-primary"><Gamepad2 size={18}/>Play Solo</button>
                  </Link>
                  <Link to="/multiplayer">
                    <button className="cta-secondary"><Users size={18}/>Multiplayer</button>
                  </Link>
                </>
              ) : (
                <>
                  <Link to="/register">
                    <button className="cta-primary">Start Playing Free</button>
                  </Link>
                  <Link to="/login">
                    <button className="cta-secondary">Log In</button>
                  </Link>
                </>
              )}
            </div>

            <div className="hero-pills">
              <span className="hero-pill"><Mountain size={13}/>75 districts</span>
              <span className="hero-pill"><MapPin size={13}/>100+ locations</span>
              <span className="hero-pill"><Trophy size={13}/>Live leaderboard</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── Modes ── */}
      <section className="modes">
        <div className="container">
          <div className="modes-grid">

            <div className="mode-card">
              <div className="mode-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=800&q=80"
                  alt="Nepali mountain landscape for solo mode"
                  loading="lazy"
                />
                <div className="mode-img-overlay" />
              </div>
              <div className="mode-body">
                <div className="mode-icon"><Gamepad2 size={20}/></div>
                <h3>Single Player</h3>
                <p>5 rounds at your own pace. No time pressure — just explore Nepal's stunning geography.</p>
                <Link to={user ? '/game' : '/login'}>
                  <button className="mode-btn">Play Solo</button>
                </Link>
              </div>
            </div>

            <div className="mode-card mode-card--accent">
              <div className="mode-img-wrap">
                <img
                  src="https://images.unsplash.com/photo-1526772662000-3f88f10405ff?w=800&q=80"
                  alt="Competitive multiplayer mode"
                  loading="lazy"
                />
                <div className="mode-img-overlay" />
              </div>
              <div className="mode-body">
                <div className="mode-icon mode-icon--gold"><Users size={20}/></div>
                <h3>Multiplayer</h3>
                <p>Challenge friends or compete worldwide in real-time. Up to 10 players per room.</p>
                <Link to={user ? '/multiplayer' : '/register'}>
                  <button className="mode-btn mode-btn--gold">Join a Game</button>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
